<template>
	<div>
		<div v-show="QAsp_gzhz">
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">OA审批-{{examine_name}}</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>

			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px;overflow-x: hidden">
				<el-row style="margin: 0px;">
					<el-row>
						<el-table :header-cell-style="{ background: '#d3eae2', color: '#000000' }" :border="true"
							:row-class-name="tableRowClassName" ref="table" :data="tableData" height="650"
							:summary-method="getSummaries" tooltip-effect="dark" style="width: 100%;"
							@selection-change="handleSelectionChange">
							<el-table-column type="selection" align="center" width="55">
							</el-table-column>
							<el-table-column align="center" label="序号" width="50">
								<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
							</el-table-column>
							<el-table-column prop="organize_name" align="center" label="项目名称" width="200">
							</el-table-column>
							<el-table-column align="center" label="收入">
								<el-table-column prop="invoiced_amount" align="center" label="开发票金额" width="120">
								</el-table-column>
								<el-table-column align="center" label="开票明细">
									<el-table-column prop="wage_quota" align="center" label="工资定额" width="100">
									</el-table-column>
									<el-table-column prop="contract_amount" align="center" label="合同金额" width="100">
									</el-table-column>
									<el-table-column prop="quota_proportion" align="center" label="定额占比" width="100">
									</el-table-column>
								</el-table-column>
							</el-table-column>
							<el-table-column align="center" label="工资明细">
								<el-table-column prop="number_of_investors" align="center" label="开资人数" width="120">
								</el-table-column>
								<el-table-column prop="payroll_payable" align="center" label="开资表应发工资" width="120">
								</el-table-column>
								<el-table-column prop="personal_part_of_social_security" align="center" label="社保个人部分"
									width="120"></el-table-column>
								<el-table-column prop="accumulation_fund_deduction" align="center" label="公积金扣款"
									width="120"></el-table-column>
								<el-table-column prop="accident_insurance_deduction" align="center" label="意外保险扣款"
									width="120"></el-table-column>
								<el-table-column prop="clothing_deposit" align="center" label="服装押金" width="120">
								</el-table-column>
								<el-table-column prop="payroll_actual_salary" align="center" label="工资表实发工资"
									width="120"></el-table-column>
							</el-table-column>
							<el-table-column prop="proportion_wages" align="center" label="工资占比"></el-table-column>
							<el-table-column prop="remarks" align="center" label="备注" width="200"></el-table-column>
							<!-- <el-table-column align="center" label="状态" width="150">
								<template slot-scope="scope">
									<img src="../../../assets/待审批.png" v-show="scope.row.spare5 === '0'" />
									<img src="../../../assets/已同意.png" v-show="scope.row.spare5 === '1'" />
								</template>
							</el-table-column> -->
							<el-table-column align="center" label="操作" width="80">
								<template slot-scope="scope">
									<span style="color:#01714d;" @click="goZhanBi(scope.row)">详情</span>
								</template>
							</el-table-column>
						</el-table>
					</el-row>
				</el-row>

				<el-row v-show="is_reviewer_state == 0">
					<el-col style="margin:50px 500px;">
						<el-button type="goon" @click="$refs['examine'].save(id, 1)">同意</el-button>
						<el-button type="addbtn" @click="$refs['examine'].reject(id)">驳回</el-button>
					</el-col>
				</el-row>
				<el-row style="display: flex; justify-content: flex-start;flex-wrap: wrap;margin: 0 20px;">
					<div v-for="(item,index) in infor" style="flex:1; width: calc((100% - 20px) / 6);min-width: calc((100% - 20px) / 6);max-width: calc((100% - 20px) / 6);">
						<div style="margin:20px 0;font-size:18px;">{{item.role_name}} : {{item.staff_name}}</div>
					</div>
				</el-row>
			</div>

		</div>
		<examine ref="examine" :spare="spare" :id="id"></examine>
		<gzzb v-show="gzzb" ref="gzzb" :gzzbList="gzzbList" :inforchild="inforchild" :organize_name="organize_name"></gzzb>
	</div>
</template>

<script>
	import axios from "axios";
	import examine from "./OA_examine.vue";
	import gzzb from "./Gzhz_gzzb.vue";
	export default {
		components: {
			examine: examine,
			gzzb:gzzb,
		},
		props: ["editData", "id","infor","examine_name", "reviewer_state", "spare", "is_reviewer_state"],
		data() {
			return {
				organize_name:"",
				editData: {},
				inforchild:{},
				tableData: [],
				gzzbList:[],
				QAsp_gzhz:true,
				gzzb:false,
			};
		},
		methods: {
			
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						alert('submit!');
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			
			async edit() {
				var result = await this.$globals.AxiosPost("examine/DetailsFind", {
					examine_id: this.editData.examine_id,
					examine_type: this.editData.examine_type
				});
				this.tableData = result.data.detailed;

			},
			async goZhanBi(e) {
				this.organize_name = e.organize_name;
				
				axios.get(this.$globals.http + 'examineDetails/getExamineUserFour', {
					params: {
						organizeId: e.id
					}
				}).then(res => {
					this.inforchild = res.data.data;
				}).catch(err => {
					console.log(err)
				});
				axios.get(this.$globals.http + 'examine/selectProportionTableList', {
					params: {
						id: e.id
					}
				}).then(res => {
					this.gzzbList = res.data.data;
					this.QAsp_gzhz = false;
					this.gzzb = true;
				}).catch(err => {
					console.log(err)
				})
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			Return() {
				this.$parent.Return();
			},
			close(){
				this.gzzb = false;
				this.QAsp_gzhz = true;
			},
			
		}
	}
</script>

<style>
	.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
		content: '';
	}
</style>



// WEBPACK FOOTER //
// QAsp_gzhz.vue?05a8af47